import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "4bd81726-8fe8-405e-86ef-e501635f4f04",
    content:
      "Single-number sound reduction index for measured R’ is<br>larger than single number value for reference curve.",
    options: {},
  },
  {
    id: "9eb16db3-8e8c-4d64-b1f1-27bba2c1a4bc",
    content: "The sum of unfavourable deviations is lower than 2.",
    options: {},
  },
  { id: "ca2f48a6-0478-47a0-8dcf-e6d0a65cddcb", content: "There are no unfavourable deviations.", options: {} },
  {
    id: "2addaf22-37bb-4c08-8582-2e28696afa41",
    content:
      "The reference curve should be shifted down to obtain<br>single numher value for the measured sound insulation curve.",
    options: {},
  },
];

export const task: Task = {
  id: "8d1a081a-f77f-41da-b120-2d23b5d7f1ba",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["2addaf22-37bb-4c08-8582-2e28696afa41"],
};
